import { createRequestActionTypes, API_URL } from "../../../actions";

export const GET_TENSOR_LISTS_URL = `${API_URL}/lists/history`;
export const CREATE_TENSOR_LISTS_URL = `${API_URL}/lists/create`;

export const tensorListsActionTypes = {
  getTensorLists: createRequestActionTypes("GET_TENSOR_LISTS"),
  createTensorLists: createRequestActionTypes("CREATE_TENSOR_LISTS"),
};
